import * as Constants from '../constants/auth';

export const getAuthUser = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_AUTH_USER_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/me/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_AUTH_USER_SUCCESS, payload: res.data.me });
        resolve(res.data.me);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_AUTH_USER_FAILED, payload: error });
        reject(error);
      });
  });
